document.addEventListener('DOMContentLoaded', () => {
  const textInput = document.getElementById('diplome-list-input');
  const hiddenInput = document.getElementById('acf-field_683489520fb11');
  const brancheSelect = document.querySelector('#branche_professionnelle select');
  const diplomePrepare = document.getElementById('diplome_prepare');

  if (!textInput || !hiddenInput || !brancheSelect || !diplomePrepare) return;

  const customList = document.getElementById('diplome-list');

  textInput.parentElement.style.position = 'relative';
  textInput.parentElement.appendChild(customList);

  let timeout;
  let currentData = [];
  let closedByEscape = false;


  function showErrorMessage() {
    if (diplomePrepare.querySelector('.c-form-note--error')) return;

    const control = diplomePrepare.querySelector('.c-form-field__control');
    if (!control) return;

    const errorDiv = document.createElement('div');
    errorDiv.className = 'c-form-note c-form-note--error';
    errorDiv.innerHTML = `
      <p class="c-form-note__text">Une branche professionnelle doit être sélectionnée</p>
    `;
    control.parentNode.insertBefore(errorDiv, control);
  }

  function removeErrorMessage() {
    const existing = diplomePrepare.querySelector('.c-form-note--error');
    if (existing) existing.remove();
  }

  function checkBrancheBeforeInteraction() {
    if (!brancheSelect.value) {
      showErrorMessage();
      return false;
    }
    removeErrorMessage();
    return true;
  }

  function createOptionElement(item) {
    const option = document.createElement('li');
    option.textContent = item.label;
    option.setAttribute('class', 'c-comparator__list-item');
    option.setAttribute('data-code', item.code);
    option.setAttribute('tabindex', '0');

    option.addEventListener('click', () => {
      textInput.value = item.label;
      hiddenInput.value = item.code;

      customList.style.display = 'none';
      currentData = [];
      textInput.focus();
    });

    option.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        option.click();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = option.nextElementSibling;
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = option.previousElementSibling;
        if (prev) prev.focus();
        else textInput.focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closedByEscape = true;
        customList.style.display = 'none';
        textInput.focus();
      }
    });

    return option;
  }

  function showCustomList() {
    if (currentData.length > 0) {
      customList.style.display = 'block';
    }
  }

  function fetchDiplomes() {
    const query = textInput.value.trim();
    if (query.length < 3) {
      customList.innerHTML = '';
      customList.style.display = 'none';
      currentData = [];
      return;
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const branche = brancheSelect.value;
      const baseUrl = `${window.location.origin}/opco-admin/wp-admin/admin-ajax.php`;
      const url = `${baseUrl}?action=recherche_formation&branche=${encodeURIComponent(branche)}&formation=${encodeURIComponent(query)}`;

      fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.text();
        })
        .then(responseText => {
          let data;
          try {
            data = JSON.parse(responseText);
          } catch (parseError) {
            console.error('Erreur de parsing JSON :', parseError);
            throw new Error('Réponse non-JSON reçue du serveur');
          }

          customList.innerHTML = '';
          currentData = [];

          const allItems = [];
          const results = data.success ? data.data : data;

          if (Array.isArray(results.training)) {
            results.training.forEach(item => {
              if (item.label && item.code) {
                allItems.push({...item, type: 'Formation'});
              }
            });
          }

          if (Array.isArray(results.domain)) {
            results.domain.forEach(item => {
              if (item.label && item.code) {
                allItems.push({...item, type: 'Domaine'});
              }
            });
          }

          if (Array.isArray(results.formacode)) {
            results.formacode.forEach(item => {
              if (item.label && item.code) {
                allItems.push({...item, type: 'Formacode'});
              }
            });
          }

          currentData = allItems;

          allItems.forEach(item => {
            const optionElement = createOptionElement(item);
            customList.appendChild(optionElement);
          });

          if (allItems.length > 0) {
            showCustomList();
          }
        })
        .catch(err => {
          console.error('Erreur lors du chargement des diplômes :', err);
          customList.innerHTML = '';
          customList.style.display = 'none';
          currentData = [];
        });
    }, 200);
  }

  textInput.addEventListener('input', () => {
    closedByEscape = false;
    hiddenInput.value = '';
    if (!checkBrancheBeforeInteraction()) return;
    fetchDiplomes();
  });

  textInput.addEventListener('focus', () => {
    if (!checkBrancheBeforeInteraction()) return;
    if (closedByEscape) return;
    if (currentData.length > 0) showCustomList();
  });

  textInput.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closedByEscape = true;
      customList.style.display = 'none';
    }
  });

  document.addEventListener('mousedown', (e) => {
    if (textInput.contains(e.target) || customList.contains(e.target)) {
      return;
    }

    customList.style.display = 'none';
  });

  brancheSelect.addEventListener('change', () => {
    checkBrancheBeforeInteraction();
    fetchDiplomes();
  });
});
